import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { SnackbarProvider } from 'notistack';
import styled from 'styled-components';
import Header from '../components/PergoHeader/PergoHeader';
import { isLoggedIn, siteSetting } from 'services/loginService';

const MainLayout = ({ children, hideHeader, isCallCenter }) => {
  const loggedIn = isLoggedIn();
  const useRingCentral = siteSetting()?.settings?.use_ringcentral == 1;

  useEffect(() => {
    const scriptId = 'ringcentral-adapter-script';
    if (loggedIn && useRingCentral) {
      if (document.getElementById(scriptId)) {
        window.RCAdapterInit();
        window.RCAdapter.setMinimized(true);
        return;
      }

      const script = document.createElement('script');
      script.id = scriptId;
      script.src =
        'https://apps.ringcentral.com/integration/ringcentral-embeddable/latest/adapter.js';
      script.async = true;

      document.body.appendChild(script);
    } else {
      if (window.RCAdapter) {
        try {
          window.RCAdapterDispose();
        } catch (e) {
          console.warn('RCAdapter destroy failed', e);
        }
      }
    }
  }, [loggedIn]);

  return (
    <>
      <SnackbarProvider>
        <Helmet>
          <meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests" />
        </Helmet>
        <AppContainer>
          {!hideHeader && <Header isCallCenter={isCallCenter} />}
          <div className="body-container">
            <main>{children}</main>
          </div>
        </AppContainer>
      </SnackbarProvider>
    </>
  );
}

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MainLayout;

const AppContainer = styled.div``;
